import { connect } from '../store/connect';
import { actions, selectors } from './';
import { SportContext } from '../app/sport-context';
import { getRouter } from '../routing/route-base';

export class SiteSportContext extends SportContext {
    constructor() {
        super();
    }

    handleSportSelected(sport) {
        const router = getRouter();
        //this.actions.setSport({ sport: name });
        router.navigateByName('site-list', { sport });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            sport: selectors.siteSportSelector(state),
            sportOptions: selectors.siteSportOptionsSelector(state),
        };
    };
};

customElements.define('site-sport-context', connect(mapStateToProps, actions)(SiteSportContext));
